import CreateStoredInstrumentPaymentAttempt from "./CreateStoredInstrumentPaymentAttempt.graphql";
import CreateKeyedPaymentAttemptMutation from "./CreateKeyedPaymentAttempt.graphql";
import CreateKeyedPaymentAttemptAndSaveInstrumentMutation from "./CreateKeyedPaymentAttemptAndSaveInstrument.graphql";
import CreateBankPaymentAttemptMutation from "./CreateBankPaymentAttempt.graphql";
import CreateBankPaymentAttemptAndSaveInstrumentMutation from "./CreateBankPaymentAttemptAndSaveInstrument.graphql";
import GetInvoiceById from "./GetInvoice.graphql";
import Obligations from "./GetVisitId.graphql";
import { createQuery } from "../../../../../util/graphql";

export const createStoredInstrumentPaymentAttempt = ({
  endpoint,
  clientSlug,
  authToken,
  items,
  customAttributes,
  serviceFee,
  routingKey,
  payingWith,
  paymentInstrumentId,
  accountId,
  payer,
  traceNumber,
  captchaToken,
  captchaProvider,
  subClientSlug,
  paymentInitiator,
  visitId,
  invoiceId
}) =>
  createQuery(
    endpoint,
    clientSlug,
    authToken
  )(CreateStoredInstrumentPaymentAttempt, {
    items,
    traceNumber,
    customAttributes,
    serviceFee,
    routingKey,
    payingWith,
    paymentInstrumentId,
    accountId,
    captchaToken,
    captchaProvider,
    ...payer,
    subClientSlug,
    paymentInitiator,
    visitId,
    invoiceId
  });

const keyedPaymentAttemptVariables = ({
  items,
  customAttributes,
  serviceFee,
  routingKey,
  cardNumber,
  cvv,
  expirationMonth,
  expirationYear,
  accountId,
  payer,
  traceNumber,
  captchaToken,
  captchaProvider,
  subClientSlug,
  paymentInitiator,
  visitId,
  invoiceId
}) => ({
  items,
  traceNumber,
  customAttributes,
  serviceFee,
  routingKey,
  cardNumber,
  cvv,
  expirationMonth,
  expirationYear,
  accountId,
  captchaToken,
  captchaProvider,
  ...payer,
  subClientSlug,
  paymentInitiator,
  visitId,
  invoiceId
});

export const createKeyedPaymentAttempt = params =>
  createQuery(
    params.endpoint,
    params.clientSlug,
    params.authToken
  )(CreateKeyedPaymentAttemptMutation, keyedPaymentAttemptVariables(params));

export const createKeyedPaymentAttemptAndSaveInstrument = params =>
  createQuery(
    params.endpoint,
    params.clientSlug,
    params.authToken
  )(CreateKeyedPaymentAttemptAndSaveInstrumentMutation, {
    ...keyedPaymentAttemptVariables(params),
    instrumentUserId: params.instrumentUserId,
    instrumentClientSlug: params.instrumentClientSlug
  });

const bankPaymentAttemptVariables = ({
  items,
  customAttributes,
  serviceFee,
  routingKey,
  accountType,
  routingNumber,
  accountNumber,
  accountId,
  payer,
  traceNumber,
  captchaToken,
  captchaProvider,
  subClientSlug,
  paymentInitiator,
  visitId,
  invoiceId
}) => ({
  traceNumber,
  items,
  customAttributes,
  serviceFee,
  routingKey,
  accountType,
  routingNumber,
  accountNumber,
  accountId,
  captchaToken,
  captchaProvider,
  ...payer,
  subClientSlug,
  paymentInitiator,
  visitId,
  invoiceId
});

export const createBankPaymentAttempt = params =>
  createQuery(
    params.endpoint,
    params.clientSlug,
    params.authToken
  )(CreateBankPaymentAttemptMutation, bankPaymentAttemptVariables(params));

export const createBankPaymentAttemptAndSaveInstrument = params =>
  createQuery(
    params.endpoint,
    params.clientSlug,
    params.authToken
  )(CreateBankPaymentAttemptAndSaveInstrumentMutation, {
    ...bankPaymentAttemptVariables(params),
    instrumentUserId: params.instrumentUserId,
    instrumentClientSlug: params.instrumentClientSlug
  });

export const getInvoice = ({ endpoint, clientSlug, authToken, invoiceId }) =>
  createQuery(
    endpoint,
    clientSlug,
    authToken
  )(GetInvoiceById, {
    id: invoiceId
  });

export const getVisitId = ({
  endpoint,
  client,
  clientSlug,
  authToken,
  accountId
}) =>
  createQuery(
    endpoint,
    clientSlug,
    authToken
  )(Obligations, {
    client,
    accountId
  });
